// extracted by mini-css-extract-plugin
export var Cta = "cta-module--Cta--28084";
export var Cta___bounded = "cta-module--Cta___bounded--8fc78";
export var Cta___flexWidth = "cta-module--Cta___flexWidth--76cd9";
export var Cta___light = "cta-module--Cta___light--4c584";
export var Cta_arrow = "cta-module--Cta_arrow--9f606";
export var Cta_content = "cta-module--Cta_content--574b2";
export var Cta_description = "cta-module--Cta_description--5b31c";
export var Cta_img = "cta-module--Cta_img--d37bf";
export var Cta_title = "cta-module--Cta_title--e31db";
export var slideIn = "cta-module--slide-in--4173b";
export var slideInFromRight = "cta-module--slide-in-from-right--6f91f";